import { Routes } from "@angular/router";
import { AuthComponent } from "../auth/feature/auth.component";
import { RegisterComponent } from "../auth/feature/register.component";
import { ResetPasswordComponent } from "../auth/feature/reset-password.component";

export const authRoutes: Routes = [
    { path: 'login', component: AuthComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'reset-password', component: ResetPasswordComponent }
    // { path: 'auth/google'}
]